import axiosInstance, { getNewCancelToken } from '@/services/_AxiosInstance';

export default class MasterApi {
  masterName;

  masterPrefix;

  constructor() {
    this.api = axiosInstance.create({
      baseURL: process.env.VUE_APP_API_URL,
    });
    this.masterPrefix = 'master';
  }

  buildPath(id) {
    const segments = [this.masterPrefix, this.masterName, id]
      .filter((segment) => segment !== undefined && segment !== null && segment !== '')
      .map((segment) => String(segment).replace(/^\/+|\/+$/g, ''));

    return `/${segments.join('/')}`;
  }

  async getAll(params) {
    try {
      const res = await this.api.get(this.buildPath(), {
        params,
        cancelToken: getNewCancelToken(),
      });
      return res.data;
    } catch (err) {
      return Promise.reject(err);
    }
  }

  async get(id) {
    try {
      const res = await this.api.get(this.buildPath(id), {
        cancelToken: getNewCancelToken(),
      });
      return res.data;
    } catch (err) {
      return Promise.reject(err);
    }
  }

  async create(data) {
    try {
      const res = await this.api.post(this.buildPath(), data, {
        cancelToken: getNewCancelToken(),
      });
      return res.data;
    } catch (err) {
      return Promise.reject(err);
    }
  }

  async update(id, data) {
    try {
      const res = await this.api.put(this.buildPath(id), data, {
        cancelToken: getNewCancelToken(),
      });
      return res.data;
    } catch (err) {
      return Promise.reject(err);
    }
  }

  async delete(id) {
    try {
      const res = await this.api.delete(this.buildPath(id), {
        cancelToken: getNewCancelToken(),
      });
      return res.data;
    } catch (err) {
      return Promise.reject(err);
    }
  }
}
